import React from 'react';

export default class ChartErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error('[ChartErrorBoundary] chart failed to render', error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="w-full p-4 bg-[#1d1d1d] rounded-lg text-gray-400 text-sm">
          Chart could not be rendered.
        </div>
      );
    }
    return this.props.children;
  }
}
